// Trading the Google token for one of ours, in one place because two callers
// need it: the sign-in button, and AuthContext's silent renewal.
//
// Google's implicit flow caps its access token at an hour, which is why
// signing in used to come round again several times a day. /api/session
// takes that token, confirms it with Google once, and hands back a token
// the backend signed itself and will accept for a day.
//
// The fallback matters as much as the exchange. This frontend deploys to
// Firebase on its own, separately from the backend, so a browser can load a
// build that knows about /api/session and talk to a service that does not.
// When anything at all goes wrong -- route missing, no signing key
// configured, the network -- this returns the Google token and its own
// expiry, which is precisely what every request carried before, so the worst
// case is the hourly sign-in we have now rather than a locked-out team.

export const startSession = async (googleToken, baseUrl, googleExpiresIn) => {
    const fallback = { token: googleToken, expiresIn: googleExpiresIn };
    try {
        const resp = await fetch(`${baseUrl}/api/session`, {
            method: 'POST',
            headers: { Authorization: `Bearer ${googleToken}` },
        });
        if (!resp.ok) {
            console.warn('No day-long session available, using the Google token:', resp.status);
            return fallback;
        }
        const data = await resp.json();
        if (!data || !data.token) {
            return fallback;
        }
        return { token: data.token, expiresIn: data.expires_in };
    } catch (error) {
        console.warn('Could not start a session, using the Google token:', error);
        return fallback;
    }
};
